export const AUTH_URLS = {
  FORGOT_PASSWORD: '/auth/forgot-password',
  FORGOT_USERNAME: '/auth/forgot-username',
  LOGIN: '/auth/login',
  OKTA: '/auth/okta',
  REGISTRATION: '/auth/registration',
  RESPONSIBLE_PARTY_REGISTRATION: '/auth/responsiblePartyRegistration',
};
